import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "my-2 mx-2 bg-white z-10 rounded-lg overflow-hidden border" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col sm:flex-row"
}
const _hoisted_3 = { class: "max-w-full overflow-auto" }
const _hoisted_4 = ["data-id"]
const _hoisted_5 = ["textContent"]
const _hoisted_6 = ["onClick", "textContent"]
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.openedFrames?.length > 0)
      ? (_openBlock(), _createElementBlock("nav", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_draggable, {
              ref: "tabs-wrapper",
              modelValue: _ctx.frames,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.frames) = $event)),
              tag: "ul",
              "item-key": "id",
              class: "inline-flex flex-nowrap flex-row"
            }, {
              item: _withCtx(({ element: frame, index: frameIndex }: any) => [
                _createElementVNode("li", {
                  "data-id": frame.id,
                  class: "flex-initial relative select-none border-r"
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass([{
                                    'pr-9': frame.closable !== false,
                                    'pr-4': frame.closable === false,
                                }, "py-3 pl-4 pb-3.5 block font-medium whitespace-nowrap opacity-0"]),
                    textContent: _toDisplayString(frame.title)
                  }, null, 10, _hoisted_5),
                  _createElementVNode("button", {
                    class: _normalizeClass(["absolute top-0 left-0 text-gray-600 py-3 pl-4 block hover:text-blue-500 focus:outline-none whitespace-nowrap", {
                                    'text-blue-500 border-b-2 font-medium border-blue-500':
                                        frameIndex === _ctx.openedTab,
                                    'pr-9': frame.closable !== false,
                                    'pr-4': frame.closable === false,
                                }]),
                    onClick: ($event: any) => (_ctx.$emit('tab-click', frameIndex)),
                    textContent: _toDisplayString(frame.title)
                  }, null, 10, _hoisted_6),
                  (frame.closable !== false)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "absolute right-2 top-2 mt-1.5 bg-gray-200 text-center px-1.5 py-0 rounded-full text-sm text-gray-500 font-medium transition-colors hover:bg-gray-400 hover:text-white",
                        onClick: ($event: any) => (_ctx.$emit('tab-close', frameIndex)),
                        textContent: '×'
                      }, null, 8, _hoisted_7))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_4)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}